// Pendências de promoção a Knowledge oficial (spec-013-knowledge-por-
// escritorio-e-promocao-de-decisao, r3, [T030], `contracts/ui-components.md`
// §5b/UC-8). Arquivo PRÓPRIO — `Text.js` já estava no teto de 500 linhas antes
// desta task; reexportado em `Text.js` no molde de `Text.aprendizado.js` /
// `Text.memoria.js` / `Text.curadoria.js`.
//
// O componente `conhecimento-pendencias.vue` é BURRO: só desenha e emite
// `@registrar`/`@descartar` — quem chama a API (listar, descartar, abrir o
// modal `conhecimento-promover` com prefill) é `view-conhecimento.vue`
// ([T031]). O texto do motivo do descarte mora aqui porque é o MESMO texto
// que a view usa no `$showModal` — fonte única.

// `PendenciaPromocaoView.reason` (`knowledge/pendencias.py::_view_de_linha`)
// — os DOIS únicos valores possíveis, medidos no backend real (H9 REFUTADA,
// `tasks.md` erratas da T000): NÃO são `knowledge_conflict`/`knowledge_
// sugerido` como o texto original da task sugeria.
export const KNOWLEDGE_PENDENCIA_ORIGEM_LABELS = {
  KNOWLEDGE_SUGERIDO: 'Sugestão',
  KNOWLEDGE_CONFLITO: 'Conflito com regra vigente',
}

// Cor do `BaseStatus text` por origem — SEMPRE acompanhada de texto (nunca só
// cor), regra de acessibilidade da casa (§7 do contrato).
export const KNOWLEDGE_PENDENCIA_ORIGEM_CORES = {
  KNOWLEDGE_SUGERIDO: 'warning',
  KNOWLEDGE_CONFLITO: 'error',
}

export const PENDENCIAS_TEXT = {
  titulo: 'Pendências de promoção',
  subtitulo:
    'A IA encontrou fatos que parecem regra oficial. Registre ou descarte. Nada vira conhecimento sozinho.',
  // Literal EXATO do AC (`spec.md:202`, SHOULD-3 do QA013 it.1) — a seção
  // agora SEMPRE renderiza (nunca mais escondida com 0 pendências); é este
  // texto que a `BaseTable` (`no-data-text`) mostra no lugar da tabela.
  vazio: 'Nenhuma pendência de promoção. Quando a IA encontrar um fato que parece regra oficial, ele aparece aqui.',
  erro: 'Não foi possível carregar as pendências de promoção.',
  avisoChaveSugerida: 'sugestão: você edita antes de confirmar',
  semTipoSugerido: 'tipo não identificado',
  registrar: 'Registrar como conhecimento oficial',
  descartar: 'Descartar',
  motivoLabel: 'Motivo do descarte',
  motivoObrigatorio: 'Informe o motivo (mínimo 5 caracteres).',
}

// `conhecimento-pendencias.vue` ([T030]) — BaseTable compacta,
// `ui-components.md` §5b: Origem, "O que a IA aprendeu", Chave sugerida,
// Regra vigente (só em conflito), Quando, ações. Sem coluna de seleção — não
// há ação em lote (cada pendência é uma decisão).
export const KNOWLEDGE_PENDENCIA_HEADERS = [
  { text: 'Origem', value: 'reason', sortable: false },
  { text: 'O que a IA aprendeu', value: 'texto_do_fato', sortable: false },
  { text: 'Chave sugerida', value: 'chave_sugerida', sortable: false },
  { text: 'Regra vigente', value: 'item_vigente', sortable: false },
  { text: 'Quando', value: 'requested_at', sortable: true },
  {
    text: '',
    value: 'actions',
    align: 'center',
    sortable: false,
    width: '96px',
  },
]
